export const REDUCER_KEY = "jazzPlaylists";
export const SET_JAZZ_PLAYLISTS = "SET_JAZZ_PLAYLISTS";
export const SET_JAZZ_PLAYLISTS_SONGS = "SET_JAZZ_PLAYLISTS_SONGS";
export const RESET_JAZZ_PLAYLISTS = "RESET_JAZZ_PLAYLISTS";
export const SET_LANG_JAZZ_PLAYLISTS = "SET_LANG_JAZZ_PLAYLISTS";
export const SET_JAZZ_PLAYLISTS_DEFAULTS = "SET_JAZZ_PLAYLISTS_DEFAULTS";
